var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.48028 4.9563L8.7462 4.05176H7.66839C7.62183 3.794 7.53537 3.55719 7.40901 3.34131C7.37115 3.27663 7.32957 3.21461 7.28427 3.15526L8.48028 3.16187L8.75 2.25H3.77732L3.5 3.22412H4.94356C5.483 3.22412 5.87934 3.34497 6.1326 3.58667C6.26932 3.71715 6.36913 3.87218 6.43205 4.05176H3.76592L3.5 4.9563H6.46449C6.43411 5.0699 6.38933 5.17366 6.33014 5.26758C6.20857 5.45801 6.03129 5.60327 5.7983 5.70337C5.5653 5.80347 5.28039 5.85352 4.94356 5.85352H3.59497L3.60257 6.56763L6.32254 9.75H7.70912V9.68774L5.22467 6.75439L5.25886 6.74707C5.84389 6.71289 6.31621 6.59448 6.67583 6.39185C7.03546 6.18921 7.29758 5.92676 7.46219 5.60449C7.56502 5.40319 7.63573 5.18713 7.67433 4.9563H8.48028Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 0V12H15.5V0H0.5ZM14 10.5H2V1.5H14V10.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion);
export default __webpack_public_path__ + "static/media/Union.6debf418278770c76a3b46e365722929.svg";
export { ForwardRef as ReactComponent };